/* eslint-disable no-unused-vars */
import * as React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { fetchMenuItems } from 'actions/navigation';
import Button from 'theme/Button';
import toggleClass from 'theme/dom/toggleClass';
import toggleNavigation from 'theme/dom/toggleNavigation';
import Menu from './Menu';
import Permission from './Permission';
import { resetOrder } from 'actions/orderSearch';

const $ST = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/staticTextMaps/navigation`);
const $R = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/routes`);
const $A = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app`);
const {
  PAGES,
} = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/customPages`);
class NavigationBody extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      localCurrentStaff: {
        name: null,
      },
    };
  }

  getlocalCurrentStaff = () =>
    (localStorage.getItem('usedStorage') !== undefined &&
      localStorage.getItem('usedStorage') !== 'undefined' &&
      JSON.parse(localStorage.getItem('usedStorage'))) ||
    {};

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchMenuItems());
    this.setState({ localCurrentStaff: this.getlocalCurrentStaff() });
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { liveCommerce } = nextProps;
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.setState({ localCurrentStaff: this.getlocalCurrentStaff() });
      return true;
    }
    if (
      this.state.localCurrentStaff.name !== nextState.localCurrentStaff.name ||
      liveCommerce !== null
    ) {
      return true;
    }
    return false;
  }

  componentWillUnmount() {
    this.setState({
      localCurrentStaff: {
        name: null,
      },
    });
  }

  orderRefundSearch = () => {
    const { dispatch } = this.props;
    dispatch(resetOrder());
    toggleNavigation();
  };

  render() {
    const { menuItems, pending, currentStaff, permissions, liveCommerce } =
      this.props;
    const { localCurrentStaff } = this.state;

    if (menuItems.length) {
      localStorage.setItem('localMenuItems', JSON.stringify(menuItems));
    }

    Permission.defaultProps = {
      permissions,
    };

    const hasProductListStores = ['CMC', 'Teknisyen'];
    const hasChangeItemListStores = ['CMC', 'Kurye'];
    const hasProductSearchStores = ['CMC', 'Teknisyen'];
    const hasntPackageOrderListStores = ['CMC', 'Teknisyen', 'Kurye'];
    const hasntStaffSelectionStores = ['Teknisyen', 'Kurye'];
    const hasntNewUserStores = ['Kurye'];

    const IS_SAMSUNG = $A.BRAND === 'SAMSUNG';
    const IS_CMC = localCurrentStaff.name === 'CMC';
    const isKoton = $A.BRAND === 'Koton';

    const btnConditions = {
      newCustormer: IS_SAMSUNG
        ? IS_CMC && $R.CUSTOMER_LIST.active
        : $R.CUSTOMER_LIST.active,
    };

    return (
      <section>
        <ul id='js-navigation'>
          {PAGES.filter(({ label }) => !!label).map((page, index) => {
            const { label, widget, slug } = page;
            return (
              <li key={index} onClick={() => toggleNavigation()}>
                <Link
                  to={{
                    pathname: `${$R.WIDGET_PAGES.path}${slug}`,
                    state: {
                      widgets: [
                        {
                          path: `sidebar.${[widget]}`,
                        },
                      ],
                    },
                  }}
                >
                  {label}
                </Link>
              </li>
            );
          })}

          {$A.BRAND === 'SAMSUNG' &&
            $R.PRODUCT_LIST.active &&
            localCurrentStaff &&
            hasProductListStores.includes(localCurrentStaff.name) && (
              <li>
                <Button
                  classes='pointer'
                  onClick={() => {
                    toggleClass({
                      elId: 'js-navigation',
                      className: 'active',
                    });
                    toggleClass({ elId: 'js-menu', className: 'active' });
                  }}
                >
                  {$ST.PRODUCTS}
                </Button>
              </li>
            )}
          {$A.BRAND !== 'SAMSUNG' && $R.PRODUCT_LIST.active && (
            <li>
              <Button
                classes='pointer'
                onClick={() => {
                  toggleClass({
                    elId: 'js-navigation',
                    className: 'active',
                  });
                  toggleClass({ elId: 'js-menu', className: 'active' });
                }}
              >
                {$ST.PRODUCTS}
              </Button>
            </li>
          )}
          {$A.BRAND === 'SAMSUNG' &&
            $R.PRODUCT_SEARCH.active &&
            localCurrentStaff &&
            hasProductSearchStores.includes(localCurrentStaff.name) && (
              <li onClick={() => toggleNavigation()}>
                <Link to={$R.PRODUCT_SEARCH.path}>{$ST.PRODUCT_SEARCH}</Link>
              </li>
            )}

          {$A.BRAND !== 'SAMSUNG' && $R.PRODUCT_SEARCH.active && (
            <li onClick={() => toggleNavigation()}>
              <Link to={$R.PRODUCT_SEARCH.path}>{$ST.PRODUCT_SEARCH}</Link>
            </li>
          )}
          {$R.ORDER_REFUND_SEARCH.active && (
            <li onClick={() => this.orderRefundSearch()}>
              <Link to={$R.ORDER_REFUND_SEARCH.path}>
                {$ST.ORDER_REFUND_ACCEPT}
              </Link>
            </li>
          )}
          {$R.ORDER_CANCELLATION_SEARCH &&
            $R.ORDER_CANCELLATION_SEARCH.active && (
              <li onClick={() => this.orderRefundSearch()}>
                <Link to={$R.ORDER_CANCELLATION_SEARCH.path}>
                  {$ST.ORDER_REFUND_CANCELLATION}
                </Link>
              </li>
            )}
          {$R.ORDER_ACCEPT_SEARCH.active && (
            <li onClick={() => toggleNavigation()}>
              <Link to={$R.ORDER_ACCEPT_SEARCH.path}>
                {$ST.SHOP_ORDER_ACCEPT}
              </Link>
            </li>
          )}
          {$R.ORDER_DELIVERY_SEARCH.active && (
            <li onClick={() => toggleNavigation()}>
              <Link to={$R.ORDER_DELIVERY_SEARCH.path}>
                {$ST.SHOP_ORDER_DELIVERY}
              </Link>
            </li>
          )}
          {$A.BRAND === 'SAMSUNG' &&
            $R.PACKAGE_ORDER_LIST.active &&
            localCurrentStaff &&
            !hasntPackageOrderListStores.includes(localCurrentStaff.name) && (
              <li onClick={() => toggleNavigation()}>
                <Link to={$R.PACKAGE_ORDER_LIST.path}>
                  {$ST.PACKAGE_ORDER_LIST}
                </Link>
              </li>
            )}
          {$A.BRAND !== 'SAMSUNG' && $R.PACKAGE_ORDER_LIST.active && (
            <li onClick={() => toggleNavigation()}>
              <Link to={$R.PACKAGE_ORDER_LIST.path}>
                {$ST.PACKAGE_ORDER_LIST}
              </Link>
            </li>
          )}
          {$R.TRANSFER_ORDER_LIST.active && (
            <li onClick={() => toggleNavigation()}>
              <Link to={$R.TRANSFER_ORDER_LIST.path}>
                {$ST.TRANSFER_ORDER_LIST}
              </Link>
            </li>
          )}
          {isKoton && $R.CLICK_AND_COLLECT_ORDER_LIST.active && (
            <li onClick={toggleNavigation}>
              <Link to={$R.CLICK_AND_COLLECT_ORDER_LIST.path}>
                {$ST.CLICK_AND_COLLECT_ORDER_LIST}
              </Link>
            </li>
          )}
          {$A.BRAND === 'SAMSUNG' &&
            $R.CHANGE_ITEM_LIST.active &&
            localCurrentStaff &&
            hasChangeItemListStores.includes(localCurrentStaff.name) && (
              <li onClick={() => toggleNavigation()}>
                <Link to={$R.CHANGE_ITEM_LIST.path}>
                  {$ST.CHANGE_ITEM_LIST}
                </Link>
              </li>
            )}

          {$A.BRAND === 'Samsung-b2b' &&
            $R.PAYMENT_ORDERS_ITEM_LIST.active &&
            localCurrentStaff && (
              <li onClick={() => toggleNavigation()}>
                <Link to={$R.PAYMENT_ORDERS_ITEM_LIST.path}>
                  {$ST.PAYMENT_ORDERS_ITEM_LIST}
                </Link>
              </li>
            )}

          {$A.BRAND === 'SAMSUNG' &&
            $R.ONCALL_ORDER_LIST.active &&
            localCurrentStaff &&
            localCurrentStaff.name === 'CMC' && (
              <li onClick={() => toggleNavigation()}>
                <Link to={$R.ONCALL_ORDER_LIST.path}>
                  {$ST.ONCALL_ORDER_LIST}
                </Link>
              </li>
            )}
          {$R.PACKAGE_ORDER_LIST_COLLECTING.active && (
            <Permission route={$R.PACKAGE_ORDER_LIST_COLLECTING.path}>
              <li onClick={() => toggleNavigation()}>
                <Link to={$R.PACKAGE_ORDER_LIST_COLLECTING.path}>
                  {$ST.PACKAGE_ORDER_LIST_COLLECTING}
                </Link>
              </li>
            </Permission>
          )}
          {$R.PACKAGE_ORDER_LIST_PACKAGING.active && (
            <Permission route={$R.PACKAGE_ORDER_LIST_PACKAGING.path}>
              <li onClick={() => toggleNavigation()}>
                <Link to={$R.PACKAGE_ORDER_LIST_PACKAGING.path}>
                  {$ST.PACKAGE_ORDER_LIST_PACKAGING}
                </Link>
              </li>
            </Permission>
          )}
          {$R.PACKAGE_ORDER_LIST_DISTRIBUTION.active && (
            <Permission route={$R.PACKAGE_ORDER_LIST_DISTRIBUTION.path}>
              <li onClick={() => toggleNavigation()}>
                <Link to={$R.PACKAGE_ORDER_LIST_DISTRIBUTION.path}>
                  {$ST.PACKAGE_ORDER_LIST_DISTRIBUTION}
                </Link>
              </li>
            </Permission>
          )}
          {liveCommerce && liveCommerce.isActive && (
            <Permission route={liveCommerce.url}>
              <li onClick={() => toggleNavigation()}>
                <a
                  href={liveCommerce.url.replace(
                    '{lc-token}',
                    localStorage.getItem('lc-token')
                  )}
                  target='_blank'
                >
                  {liveCommerce.name}
                </a>
              </li>
            </Permission>
          )}
          {btnConditions.newCustormer && (
            <li className='green' onClick={() => toggleNavigation()}>
              <Link
                replace
                to={{
                  pathname: $R.NEW_USER.path,
                  state: { newCustomer: true },
                }}
              >
                {$ST.NEW_CUSTOMER}
              </Link>
            </li>
          )}
          {![
            'Kapıda Instore',
            'Instore-Test',
            'Samsung Instore',
            'Samsung Teknisyen Instore',
            'Sporjinal Instore',
          ].includes($A.TITLE) && (
            <li className='green' onClick={() => toggleNavigation()}>
              <Link
                to={{
                  pathname: $R.STAFF_SELECTION.path,
                  state: { switchStaff: 1 },
                }}
              >
                {$ST.STAFF_SELECTION}
              </Link>
            </li>
          )}
          {((currentStaff !== null && currentStaff.id) ||
            (localCurrentStaff !== null && localCurrentStaff.id)) && (
            <li id='js-logout-button' className='logout'>
              <Button
                classes='pointer'
                onClick={() => {
                  this.props.logout();
                }}
              >
                {$ST.LOGOUT}
              </Button>
            </li>
          )}
        </ul>
        <ul>
          <li></li>
        </ul>
        <Menu
          menuItems={JSON.parse(localStorage.getItem('localMenuItems'))}
          depth={3}
        />
      </section>
    );
  }
}

export default withRouter(NavigationBody);



// WEBPACK FOOTER //
// ./src/components/partials/NavigationBody.js